import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Typography,
  Space,
  Checkbox,
  TimePicker,
  Avatar,
  Image,
} from "antd";
import Styles from "../TripSchedule.module.scss";
import TripStyles from "./Trip.module.scss";
import TripDeleteIcon from "../../../../assets/icons/trip_delete.svg";
import TripAddress from "../TripAddress/TripAddress";
import {
  TTrip,
  TripBothAddress,
  TripType,
  IWandaServiceArea,
  AddressType,
} from "../../../../types/TripTypes";
import DriverInstruction from "../../../../assets/icons/driver_instruction.svg";
import { useWindowSize } from "../../../../hooks/useWindowSize";
import {
  GeneralDefinition,
  TrackAnalytics,
} from "../../../../types/ApplicationTypes";
import { CloseCircleOutlined } from "@ant-design/icons";
import moment from "moment";
import { getWandaServiceArea } from "../../../../services";
import { useTripsCtx } from "../../../../context/TripDetailsContext";
import InvalidAddressPopup from "./InvalidAddressPopup/InvalidAddressPopup";
import { usePlanDetailsCtx } from "../../../../context/PlanDetailsContext";
import { useParams } from "react-router";

type Props = {
  index: number;
  trip: TTrip;
  tripLength: number;
  onAddressChange: (index: number, address: TripBothAddress) => void;
  onTripTypeChange: (index: number, tripType: string) => void;
  onDelete: (index: number) => void;
  onTimechange: (index: number, scheduledTime: string) => void;
  onClearTime: (index: number) => void;
  onFieldsClear: (index: number, field: string) => void;
  onWheelChairChange: () => void;
  onWillCallChange: (index: number) => void;
  onFieldChange: (
    index: number,
    name: string,
    value: string,
    field: string
  ) => void;
  onClearinstructionField: (index: number, field: string) => void;
  onDriverInstrctionValidation: (
    index: number,
    instruction: string,
    value: boolean
  ) => void;
};

interface IParams {
  serviceUserId: string;
}

const Trip: React.FC<Props> = ({
  index,
  trip,
  tripLength,
  onAddressChange,
  onTripTypeChange,
  onDelete,
  onTimechange,
  onClearTime,
  onFieldsClear,
  onWheelChairChange,
  onWillCallChange,
  onFieldChange,
  onClearinstructionField,
  onDriverInstrctionValidation,
}) => {
  const { width } = useWindowSize();
  const [isCollapseOpen, setIsCollapseOpen] = useState(false);
  const handleAddressUpdate = (tripaddress: TripBothAddress) => {
    onAddressChange(index, tripaddress);
  };
  const params = useParams<IParams>();

  const handleChangeOtherFields = (
    name: string,
    value: string,
    field: string
  ) => {
    onFieldChange(index, name, value, field);
  };

  const handleClearinstructionField = (field: string) => {
    onClearinstructionField(index, field);
  };

  const handleClearAddressFields = (field: string) => {
    onFieldsClear(index, field);
    if (index === 0 && field === AddressType.Pickup) {
      setWandaService([]);
    }
  };

  const handlecheckDriverInstrction = (instruction: string, value: boolean) => {
    onDriverInstrctionValidation(index, instruction, value);
  };
  const { wandaServiceAreaCtx, serviceDataCtx } = useTripsCtx();
  const [wandaService, setWandaService] = wandaServiceAreaCtx;
  const [isNotCovergeZip, setIsNotCovergeZip] = useState<boolean>(false);
  const { tripDetailsInfo } = usePlanDetailsCtx();
  const [serviceData] = serviceDataCtx;

  const VehicleTranfer = () => {
    const serviceUser = serviceData?.find(
      (data: { personId: number }) =>
        data.personId === Number(params.serviceUserId)
    );

    const transferWheelChairPresent =
      serviceUser?.wandaAccommodations?.wheelChairPresent;
    const wcToVehicleTransfer =
      serviceUser?.wandaAccommodations?.wcToVehicleTransfer;

    if (transferWheelChairPresent && wcToVehicleTransfer) {
      return "Standard, foldable wheelchair · Able to transfer";
    } else if (transferWheelChairPresent && !wcToVehicleTransfer) {
      return "Standard, foldable wheelchair · Not able to transfer";
    } else if (!transferWheelChairPresent && !wcToVehicleTransfer) {
      return "Non-foldable wheelchair · Not able to transfer";
    } else {
      return "Non-foldable wheelchair · Able to transfer";
    }
  };

  const vehicleTransferStatus = VehicleTranfer();

  useEffect(() => {
    VehicleTranfer();
  }, []);

  const handleWandaService = (zipCode: string, addressType: string) => {
    getServiceArea(zipCode, addressType);
  };

  const getServiceArea = async (zipCode: string, addressType: string) => {
    let serviceArea: IWandaServiceArea[] = await getWandaServiceArea(zipCode);
    if (index === 0 && addressType === AddressType.Pickup) {
      setWandaService(serviceArea);
    }
    if (serviceArea?.length === 0) {
      handleClearAddressFields(addressType);
      setIsNotCovergeZip(true);
      TrackAnalytics(
        "/DashBoard/ScheduleService/TripSchedule",
        "Out of market trip address requested",
        "Trip Scheduling Page"
      );
      return;
    }
  };

  const handleCancelCoverage = () => {
    setIsNotCovergeZip(false);
  };

  return width > GeneralDefinition.MobileView ? (
    <Row className={TripStyles.timeSection}>
      <Col md={12} lg={12} sm={6}>
        <Row gutter={[10, 0]} className={Styles.timeDeleteSection}>
          {tripLength > 1 && (
            <Col offset={10}>
              <Typography.Text className={Styles.contentTextBlue}>
                <Space>
                  <Avatar
                    size={23}
                    className={TripStyles.tripDeleteIconBackground}
                  >
                    {index + 1}
                  </Avatar>
                  <span onClick={() => onDelete(index)}>
                    {" "}
                    <Avatar
                      size={23}
                      className={TripStyles.tripDeleteIconBackground}
                    >
                      <Image src={TripDeleteIcon} preview={false} />
                    </Avatar>
                  </span>
                </Space>
              </Typography.Text>
            </Col>
          )}
          <Col offset={tripLength > 1 ? 3 : 15}>
            <Typography.Text className={Styles.contentTextBlue}>
              Time
            </Typography.Text>
          </Col>
        </Row>
        <Row gutter={[8, 0]} align="middle">
          <Col lg={{ span: 5, offset: 10 }}>
            <select
              className={`${TripStyles.timePickerCustom} ${
                trip.isWillCall ? TripStyles.arrivedByType : ""
              }`}
              onChange={(e) => e && onTripTypeChange(index, e.target.value)}
              defaultValue={
                trip.tripSelectedTypeDefault ? trip.tripSelectedTypeDefault : ""
              }
              value={
                trip.tripSelectedTypeDefault ? trip.tripSelectedTypeDefault : ""
              }
              disabled={trip.isWillCall}
            >
              {/* <option value="arrivedBy">Arrive By</option> */}
              <option value="leaveAt">Leave At</option>
            </select>
          </Col>
          <Col>
            <TimePicker
              value={
                trip.scheduleTime ? moment(trip.scheduleTime, "hh:mm A") : null
              }
              disabled={trip.isWillCall}
              id={Styles.timePickerCustom}
              popupClassName={`timePickerPopupStyle${index + 1}`}
              use12Hours
              size="large"
              format="hh:mm A"
              placeholder="--:--"
              suffixIcon={null}
              minuteStep={15}
              className={
                trip.areTimesChronological
                  ? TripStyles.timePickerError
                  : Styles.timePickerStyle
              }
              clearIcon={
                <CloseCircleOutlined
                  translate=""
                  onMouseDown={() => onClearTime(index)}
                />
              }
              onChange={(e) => e && onTimechange(index, e?.format("hh:mm A"))}
            />
          </Col>
        </Row>
        <Row>
          <Col offset={10}>
            {index === 0 && (
              <Typography.Text className={Styles.contentTextBlueLight}>
                {trip.tripSelectedTypeDefault === TripType.ArrivedBy ? (
                  <>
                    {trip.scheduleTime !== "" &&
                    trip.scheduleTime !== undefined ? (
                      <span>
                        {trip.firstName && trip.firstName} will arrive at the
                        dropoff address by {trip.scheduleTime}.
                      </span>
                    ) : (
                      <span>
                        {trip.firstName && trip.firstName} will arrive at the
                        dropoff address by this time.
                      </span>
                    )}
                  </>
                ) : (
                  <span>
                    Driver will arrive at the pickup address at this time.
                  </span>
                )}
              </Typography.Text>
            )}
            {index >= 1 && (
              <Typography.Text className={Styles.contentTextBlueLight}>
                {trip.areTimesChronological && (
                  <Typography.Text
                    className={TripStyles.timePickerErrorMessage}
                  >
                    Scheduled time must be later than the previous leg.
                  </Typography.Text>
                )}
                <Row>
                  <Col>
                    <Checkbox
                      checked={trip.isWillCall}
                      onChange={() => onWillCallChange(index)}
                    ></Checkbox>
                    <span className={TripStyles.checkTextColor}>
                      {" "}
                      I’ll call when {trip.firstName && trip.firstName} is ready
                      to be picked up.
                    </span>
                    <Image
                      preview={false}
                      onClick={(e) => {
                        e.stopPropagation();
                        setIsCollapseOpen(!isCollapseOpen);
                      }}
                      width={"16px"}
                      src={DriverInstruction}
                      alt="Information_Icon"
                    />
                  </Col>
                </Row>

                {isCollapseOpen && (
                  <Typography.Text className={Styles.contentTextBlueLight}>
                    <p>
                      {" "}
                      We'll send a driver to pick{" "}
                      {trip.firstName && trip.firstName} up after you call us at{" "}
                      {tripDetailsInfo.wandaCustomerCareNumber}
                    </p>
                  </Typography.Text>
                )}
              </Typography.Text>
            )}
          </Col>
        </Row>
      </Col>
      <Col md={11} lg={11} sm={6} offset={1}>
        <Row>
          <Col span={24}>
            <TripAddress
              address={{
                pickup: trip.pickupAddressDefault
                  ? trip.pickupAddressDefault
                  : undefined,
                dropOff: trip.dropOffAddressDefault
                  ? trip.dropOffAddressDefault
                  : undefined,
              }}
              checkDriverInstrction={handlecheckDriverInstrction}
              handleUpdate={handleAddressUpdate}
              clearinstructionField={handleClearinstructionField}
              changeOtherFields={handleChangeOtherFields}
              handleClear={handleClearAddressFields}
              checkWandaService={handleWandaService}
            />
          </Col>
        </Row>
        {trip.wheelChairTravel && trip.wheelChairTravel && (
          <Row className={TripStyles.wheelCharSection}>
            <Col>
              <Space direction="vertical" size={0}>
                <Typography.Text>
                  <Checkbox
                    checked={trip.wheelChairTravel}
                    onChange={onWheelChairChange}
                  ></Checkbox>
                  <span>
                    {" "}
                    {trip.firstName && trip.firstName} will travel with{" "}
                    <b>a wheelchair</b>.
                  </span>
                </Typography.Text>
                <Typography.Text className={TripStyles.wheelCharSectionText}>
                  {vehicleTransferStatus}
                </Typography.Text>
              </Space>
            </Col>
          </Row>
        )}
      </Col>
      <div>
        <InvalidAddressPopup
          isNotCovergeZip={isNotCovergeZip}
          handleCancelCoverage={handleCancelCoverage}
        />
      </div>
    </Row>
  ) : (
    <Row className={TripStyles.timeSection}>
      <Col span={24}>
        <Row gutter={[10, 0]} className={TripStyles.timeDeleteSection}>
          {tripLength > 1 && (
            <Col offset={10}>
              <Typography.Text className={Styles.contentTextBlue}>
                <Space>
                  <Avatar
                    size={23}
                    className={TripStyles.tripDeleteIconBackground}
                  >
                    {index + 1}
                  </Avatar>
                  <span onClick={() => onDelete(index)}>
                    {" "}
                    <Avatar
                      size={23}
                      className={TripStyles.tripDeleteIconBackground}
                    >
                      <Image src={TripDeleteIcon} preview={false} />
                    </Avatar>
                  </span>
                </Space>
              </Typography.Text>
            </Col>
          )}
          <Col offset={tripLength > 1 ? 2 : 14}>
            <Typography.Text className={Styles.contentTextBlue}>
              Time
            </Typography.Text>
          </Col>
        </Row>
        <Row gutter={[8, 0]} align="middle">
          <Col offset={2} span={10}>
            <select
              className={`${TripStyles.timePickerCustom} ${
                trip.isWillCall ? TripStyles.arrivedByType : ""
              }`}
              onChange={(e) => e && onTripTypeChange(index, e.target.value)}
              defaultValue={
                trip.tripSelectedTypeDefault ? trip.tripSelectedTypeDefault : ""
              }
              value={
                trip.tripSelectedTypeDefault ? trip.tripSelectedTypeDefault : ""
              }
              disabled={trip.isWillCall}
            >
              {/* <option value="arrivedBy">Arrive By</option> */}
              <option value="leaveAt">Leave At</option>
            </select>
          </Col>
          <Col span={10}>
            <TimePicker
              value={
                trip.scheduleTime ? moment(trip.scheduleTime, "hh:mm A") : null
              }
              disabled={trip.isWillCall}
              className={Styles.timePickerStyle}
              popupClassName={`timePickerPopupStyle${index + 1}`}
              use12Hours
              size="large"
              format="hh:mm A"
              placeholder="--:--"
              suffixIcon={null}
              minuteStep={15}
              clearIcon={
                <CloseCircleOutlined
                  translate=""
                  onMouseDown={() => onClearTime(index)}
                />
              }
              onChange={(e) => e && onTimechange(index, e?.format("hh:mm A"))}
            />
          </Col>
        </Row>
        <Row>
          <Col offset={2}>
            {index === 0 && (
              <Typography.Text className={Styles.contentTextBlueLight}>
                {trip.tripSelectedTypeDefault === TripType.ArrivedBy ? (
                  <>
                    {trip.scheduleTime !== "" ? (
                      <span>
                        {trip.firstName && trip.firstName} will arrive at the
                        dropoff address by {trip.scheduleTime}
                      </span>
                    ) : (
                      <span>
                        {trip.firstName && trip.firstName} will arrive at the
                        dropoff address by this time
                      </span>
                    )}
                  </>
                ) : (
                  <span>
                    Driver will arrive at the pickup address at this time.
                  </span>
                )}
              </Typography.Text>
            )}
            {index >= 1 && (
              <Typography.Text className={Styles.contentTextBlueLight}>
                {trip.areTimesChronological && (
                  <Typography.Text
                    className={TripStyles.timePickerErrorMessage}
                  >
                    Scheduled time must be later than the previous leg.
                  </Typography.Text>
                )}

                <Row>
                  <Col>
                    <Checkbox
                      checked={trip.isWillCall}
                      onChange={() => onWillCallChange(index)}
                    ></Checkbox>
                    <span className={TripStyles.checkTextColor}>
                      {" "}
                      I’ll call when {trip.firstName && trip.firstName} is ready
                      to be picked up.
                    </span>
                    <Image
                      preview={false}
                      onClick={(e) => {
                        e.stopPropagation();
                        setIsCollapseOpen(!isCollapseOpen);
                      }}
                      width={"16px"}
                      src={DriverInstruction}
                      alt="Information_Icon"
                    />
                  </Col>
                </Row>

                {isCollapseOpen && (
                  <Typography.Text className={Styles.contentTextBlueLight}>
                    <p>
                      {" "}
                      We'll send a driver to pick{" "}
                      {trip.firstName && trip.firstName} up after you call us at{" "}
                      {tripDetailsInfo.wandaCustomerCareNumber}
                    </p>
                  </Typography.Text>
                )}
              </Typography.Text>
            )}
          </Col>
        </Row>
      </Col>
      <Col offset={2} span={22}>
        <Row>
          <Col span={24}>
            <TripAddress
              address={{
                pickup: trip.pickupAddressDefault
                  ? trip.pickupAddressDefault
                  : undefined,
                dropOff: trip.dropOffAddressDefault
                  ? trip.dropOffAddressDefault
                  : undefined,
              }}
              checkDriverInstrction={handlecheckDriverInstrction}
              handleUpdate={handleAddressUpdate}
              clearinstructionField={handleClearinstructionField}
              changeOtherFields={handleChangeOtherFields}
              handleClear={handleClearAddressFields}
              checkWandaService={handleWandaService}
            />
          </Col>
        </Row>
        {trip.wheelChairTravel && trip.wheelChairTravel && (
          <Row className={TripStyles.wheelCharSection}>
            <Col>
              <Space direction="vertical" size={0}>
                <Typography.Text>
                  <Checkbox
                    checked={trip.wheelChairTravel}
                    onChange={onWheelChairChange}
                  ></Checkbox>
                  <span>
                    {" "}
                    {trip.firstName && trip.firstName} will travel with{" "}
                    <b>a wheelchair</b>.
                  </span>
                </Typography.Text>
                <Typography.Text className={TripStyles.wheelCharSectionText}>
                  {vehicleTransferStatus}
                </Typography.Text>
              </Space>
            </Col>
          </Row>
        )}
      </Col>
      <div>
        <InvalidAddressPopup
          isNotCovergeZip={isNotCovergeZip}
          handleCancelCoverage={handleCancelCoverage}
        />
      </div>
    </Row>
  );
};

export default Trip;
